<template>
<el-dialog :visible="visible" title="Ubigeo" width="400px" append-to-body :show-close="false">
    <el-form  :model="formUbigeo">
        <div class="row">
            <div class="col-sm-2 align-self-center px-0 text-right">
                <label class="m-0">País</label>
            </div>
            <div class="col-sm-10">
                <el-form-item prop="idcountry" class="m-0">
                    <el-select v-model="formUbigeo.idcountry" placeholder="- Seleccione -" size="small" class="w-100"></el-select>
                </el-form-item>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-sm-2 align-self-center px-0 text-right">
                <label class="m-0">Ciudad</label>
            </div>
            <div class="col-sm-10">
                <el-form-item prop="city" class="m-0">
                    <el-select v-model="formUbigeo.city" placeholder="- Seleccione -" size="small" class="w-100"></el-select>
                </el-form-item>
            </div>
        </div>
        
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">Cancelar</el-button>
        <el-button type="success" size="small" icon="el-icon-check" plain @click="onClose">Seleccionar</el-button>
    </div>
</el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        }
    },
    data: () => ({
        formUbigeo: {}
    }),
    methods: {
        onClose() {
            this.$emit("update:visible", false);
        }
    }
}
</script>
